import { Box, useTheme } from "@mui/material";

const ProgressCircle = ({ progress = "1.0", size = "60" }) => {
  const theme = useTheme();
  const angle = progress * 360;
  
  return (
    <Box
      sx={{
        background: `radial-gradient(${theme.palette.primary.lightest} 58%, transparent 60%),
          conic-gradient(transparent 0deg ${angle}deg, 
          ${theme.palette.red.deep} ${angle}deg 360deg),
          ${theme.palette.green.deep}`,
        borderRadius: "50%",
        width: `${size}px`,
        height: `${size}px`,
      }}
    />
  );
};

export default ProgressCircle;
